import { render } from "./EconomyStatusTable.vue?vue&type=template&id=44953f4a&ts=true"
import script from "./EconomyStatusTable.vue?vue&type=script&lang=ts"
export * from "./EconomyStatusTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__